import { get, set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import SEARCH_CONTEXT from '../../../../../helpers/InventorySearchContext';
import {
  onChangeQuery,
  onClearQuery
} from '../../../actions/components/search';

const defaultQuery = { q: '' };

const initialState = {
  byContext: {
    [SEARCH_CONTEXT.ITEM]: { query: defaultQuery },
    [SEARCH_CONTEXT.PACKAGE]: { query: defaultQuery },
    [SEARCH_CONTEXT.LOCATION]: { query: defaultQuery },
    [SEARCH_CONTEXT.TAG]: { query: defaultQuery },
    [SEARCH_CONTEXT.ITEM_AVAILABILITY]: { query: defaultQuery },
    [SEARCH_CONTEXT.PACKAGE_AVAILABILITY]: { query: defaultQuery }
  }
};

const onChangeQueryHandler = action => ({
  [action.toString()]: (state, { payload: { context, query } }) => {
    const contextQuery = get(`byContext.${context}.query`, state);
    return set(
      `byContext.${context}.query`,
      { ...contextQuery, ...query },
      state
    );
  }
});

const onClearQueryHandler = action => ({
  [action.toString()]: (state, { payload: { context } }) =>
    set(`byContext.${context}.query`, defaultQuery, state)
});

export default createReducer(initialState, {
  ...onChangeQueryHandler(onChangeQuery),
  ...onClearQueryHandler(onClearQuery)
});
